/**
 * Responsible for showing/hiding content based on a tab structure
 * @module modules/tabs
 */
import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

const JS_TABS_DEFAULT_OPTIONS = {
  tab: '.tabs__link',
  tabContent: '.tabs__content',
  tabContentActive: 'tabs__content--active',
  tabActive: 'tabs__link--active',
};

const makeToggleTab = ($tab, initialActiveClass, activeClass) => ($target) => {
  $tab
    .removeClass(activeClass)
    .find('.u-screen-reader')
    .remove();

  $target
    .addClass(activeClass)
    .append('<span class="u-screen-reader" aria-live="assertive"> has been selected</span>');

  if (initialActiveClass) {
    $tab.removeClass(initialActiveClass);
    $target.addClass(initialActiveClass);
  }
};

const makeToggleContent = ($content, tabContentActive) => ($target) => {
  const contentSelector = $target.data('tab-content');
  const tabHorizontalScroll = $target.data('tab-horizontal-scroll');
  const imageLoaded = $(contentSelector).find('img').first().hasClass('loaded');
  $content.removeClass(tabContentActive);
  $(contentSelector).addClass(tabContentActive);
  if (tabHorizontalScroll && !imageLoaded) {
    $(window).trigger('scroll');
  }
};
// LOGIC FOR AB TEST 789 START
// Added isFocusable for a native focus check since :focusable is not compatible with our jquery
const isFocusable = ($el) => {
  const el = $el[0];
  if (!el) return false;
  const focusableTags = ['A', 'INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'];
  const tabIndex = el.getAttribute('tabindex');
  return (
    !el.hasAttribute('disabled') &&
    (focusableTags.includes(el.tagName) || tabIndex !== null)
  );
};
// LOGIC FOR AB TEST 789 END
const tabs = (el, options = {}) => {
  const $el = $(el);
  const {
    tab,
    tabContent,
    tabActive,
    tabContentActive,
  } = Object.assign({}, JS_TABS_DEFAULT_OPTIONS, $el.data(), options);

  const $tab = $el.find(tab);
  const $content = $el.find(tabContent);
  const activeTabClass = $el.data('active-tab') ? $el.data('active-tab').replace('.', '') : false;

  const toggleTab = makeToggleTab($tab, activeTabClass, tabActive);
  const toggleContent = makeToggleContent($content, tabContentActive);

  $tab.on('click', (e) => {
    const $target = $(e.currentTarget);
    const tabUrl = $target.data('tab-url');
    const href = $target.attr('href');
    // LOGIC FOR AB TEST 789 STARTS
     // If the href starts with '#' and you want the browser to jump to that element:
    if (href && href.charAt(0) === '#' && href.length > 1 && $target.hasClass('js-anchor-scroll')) {
      toggleTab($target);
      toggleContent($target);
      // Allow the default behavior to update the URL hash and scroll to the element.
      // You can also manually scroll to the element if necessary:
      const $elementToFocus = $(href);
      if ($elementToFocus.length) {
      // Option 1: Let the default anchor behavior do its job by not preventing default.
      // Option 2: Or manually update the URL and scroll:
        const stickyNavHeight = $('.js-sticky-nav').outerHeight() || 0;
        const elementTop = $elementToFocus.offset().top;
        const scrollTarget = elementTop - stickyNavHeight;
        $('html, body').animate({
          scrollTop: scrollTarget,
        }, 400);
        // Set tabindex if not focusable
        if (!isFocusable($elementToFocus)) {
          $elementToFocus.attr('tabindex', '-1');
        }
        $elementToFocus.focus(); // Focus after scroll finishes
        window.history.pushState(null, '', href); // Update hash manually
      }
    }
    // LOGIC FOR AB TEST 789 END
    e.preventDefault();
    toggleTab($target);
    toggleContent($target);

    if (tabUrl && !$target.hasClass('loaded')) {
      $.ajax({
        url: tabUrl,
        success: (response) => {
          const contentSelector = $target.data('tab-content');
          const $tabContent = $(contentSelector);
          $tabContent.html(response).find('.horizontal-scroll').horizontalScroll();
          $target.addClass('loaded');
        },
      });
    }

    $(document).trigger('tabs:click', $target.data('tab-content'));
  });
};

registerJQueryPlugin('tabs', tabs);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/tabs.js